var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetailCourse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 62,
    viewBox: "0 0 100 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_5562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0142 60.8082C71.6152 60.8082 85.0729 47.1958 85.0729 30.4041C85.0729 13.6124 71.6152 0 55.0142 0C38.4133 0 24.9556 13.6124 24.9556 30.4041C24.9556 47.1958 38.4133 60.8082 55.0142 60.8082Z",
    fill: "#00479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1573 62C67.7582 62 81.2159 48.3876 81.2159 31.5959C81.2159 14.8042 67.7582 1.1918 51.1573 1.1918C34.5563 1.1918 21.0986 14.8042 21.0986 31.5959C21.0986 48.3876 34.5563 62 51.1573 62Z",
    fill: "#75B2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9302 47.0526C94.7582 46.693 99.5524 49.7276 99.9688 53.492C100.254 56.0856 98.6596 58.8919 96.3659 60.1572C93.2239 61.8924 90.2861 59.8816 84.1356 59.0546C80.1867 58.5403 76.1818 58.6492 72.2666 59.3775C76.1088 57.6099 79.7045 55.3472 82.9626 52.6467C86.8718 49.3942 88.0631 47.323 90.9302 47.0526Z",
    fill: "#006AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5786 45.9238C9.17193 45.509 3.64727 49.0031 3.16812 53.3398C2.8382 56.3271 4.67887 59.5587 7.31816 61.0156C10.9446 63.0186 14.3196 60.7006 21.4075 59.7503C25.9555 59.1558 30.5683 59.2798 35.0779 60.1178C30.6567 58.082 26.5196 55.476 22.7717 52.3658C18.255 48.6198 16.883 46.2336 13.5786 45.9238Z",
    fill: "#006AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26047 55.4062C9.71804 55.4062 12.5209 52.5961 12.5209 49.1296C12.5209 45.6631 9.71804 42.8529 6.26047 42.8529C2.80291 42.8529 0 45.6631 0 49.1296C0 52.5961 2.80291 55.4062 6.26047 55.4062Z",
    fill: "#00479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5694 33.627C95.2974 33.627 96.6983 32.2225 96.6983 30.49C96.6983 28.7574 95.2974 27.3529 93.5694 27.3529C91.8413 27.3529 90.4404 28.7574 90.4404 30.49C90.4404 32.2225 91.8413 33.627 93.5694 33.627Z",
    fill: "#00479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85598 33.612C7.58404 33.612 8.98491 32.2075 8.98491 30.475C8.98491 28.7424 7.58404 27.338 5.85598 27.338C4.12792 27.338 2.72705 28.7424 2.72705 30.475C2.72705 32.2075 4.12792 33.612 5.85598 33.612Z",
    fill: "#00479B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_229_5562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 16.7157H41.8179C40.1512 16.7157 38.7876 18.0833 38.7876 19.7549V44.0686C38.7876 45.7402 40.1512 47.1079 41.8179 47.1079H59.9997C61.6664 47.1079 63.03 45.7402 63.03 44.0686V19.7549C63.03 18.0833 61.6664 16.7157 59.9997 16.7157ZM46.3634 19.7549H49.3937V27.353L47.8785 26.2132L46.3634 27.353V19.7549ZM59.9997 44.0686H41.8179V19.7549H43.3331V33.4314L47.8785 30.0123L52.424 33.4314V19.7549H59.9997V44.0686Z",
    fill: "#00479B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_5562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 62,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_229_5562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.3636,
    height: 36.4706,
    fill: "white",
    transform: "translate(32.7271 13.6765)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailCourse);
export default __webpack_public_path__ + "static/media/DetailCourse.571519be46e08da44c515d89d9b5645c.svg";
export { ForwardRef as ReactComponent };